import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { OnboardingProductsStore } from 'src/app/store/store';
import { LoadingService } from '../../../services/loading.service';
import { environment } from '../../../../environments/environment';
import { UiActions } from 'src/app/store/actions';
import { StepsClientTypes } from 'src/app/shared/enums';

@Component({
  selector: 'app-derivation',
  templateUrl: './derivation.component.html',
  styleUrls: ['../../../global.scss', './derivation.component.scss']
})
export class DerivationComponent implements OnInit {
  privateMode = false;
  staticAssetsUrl = environment.staticScripts.staticAssets;

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    public loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.setService();
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
  }

  goToPrivateSite() {
    window.open('https://www.bancofalabella.pe/', '_blank');
  }

  goToAdhesion() {
    window.open('https://www.bancofalabella.pe/autoadhesion/', '_blank');
  }

  back() {
    this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_PRIVATE_LANDING_JOINT }));
  }

  setService() {
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.privateMode ? this.store.dispatch(TagPage({text: 'derivar-sitio-publico'})) : this.store.dispatch(TagPage({text: 'derivar-ya-cliente'}));
  }
}

